import { render, staticRenderFns } from "./OrganizationMailExport.vue?vue&type=template&id=0afa2278&scoped=true"
import script from "./OrganizationMailExport.vue?vue&type=script&lang=js"
export * from "./OrganizationMailExport.vue?vue&type=script&lang=js"
import style0 from "./OrganizationMailExport.vue?vue&type=style&index=0&id=0afa2278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afa2278",
  null
  
)

export default component.exports